import { observer } from "mobx-react";
import { ICompareValueTypeComponentProps } from "../condition-field";
import TagCompareValueStore from "../../../../../../../stores/compare-value/tag-compare-value-store";
import { TEXTAREA_VARIANTS, Textarea } from "../../../../../../../../../components/inputs/textarea/textarea";

const TagCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: TagCompareValueStore = store as TagCompareValueStore;

    return (
        <>
            {operatorSelector}

            <Textarea disabled={!condition.isEditMode} value={compareValueStore.value} onChange={(v) => compareValueStore.setValue(v as string)} variant={TEXTAREA_VARIANTS.FIT_CONTENT} placeholder={condition.placeholder} />
        </>
    );
});

export default TagCompareValueField;